export const showIniciais = (nome) => {
    if (nome != undefined && nome.length > 11) {
        var pastaName = nome.substring(0, Math.min(nome.length, 11));
        return pastaName + '...';
    }

    return nome;
}